import React from 'react';
import { useHistory } from 'react-router-dom';
import { IonContent, IonPage } from '@ionic/react';
import { LinkList } from '../components/Dashboard/Links/LinkList';
import { LinkModel } from '../types/link';
import DashboardLayout from '../components/Dashboard/DashboardLayout';

const Links: React.FC = () => {
  const history = useHistory();

  const handleLinkSelect = (link: LinkModel) => {
    history.push(`/links/edit/${link.id}`);
  };

  const handleLinkCreate = () => {
    history.push('/links/new');
  };

  return (
    <DashboardLayout>
      <IonPage>
        <IonContent className="ion-padding">
          <LinkList
            onLinkSelect={handleLinkSelect}
            onLinkCreate={handleLinkCreate}
          />
        </IonContent>
      </IonPage>
    </DashboardLayout>
  );
};

export default Links; 